import DaysBgPattern from './DaysBgPattern'

const Days = class {
  constructor(chart) {
    this.mainXAxis = chart.get('main-xaxis')
    this.mainSeries = chart.get('main')
    this.volumeSeries = chart.get('volume')
    this.patternBgIds = []

    this.sma20Series = chart.get('sma-main-20')
  }

  removePatternBg() {
    let plotId

    while ((plotId = this.patternBgIds.pop())) {
      this.mainXAxis.removePlotBand(plotId)
    }
  }

  draw() {
    DaysBgPattern(this)
  }

  hide() {
    this.removePatternBg()
  }
}

export default Days
